import {
  useGetEvent,
  useGetEventLocation,
  useGetTicketsByEventId,
} from '@sunrise-ui/api-client';
import { useAuthStore } from '@sunrise-ui/primitives';
import { DateTime } from 'luxon';

export function useInPersonEventInformation(
  eventId: string,
  locationId?: string,
) {
  const { currentUserId } = useAuthStore();
  const { data: event, isLoading: isLoadingEvent } = useGetEvent(eventId);
  const { data: location, isLoading: isLoadingLocation } =
    useGetEventLocation(locationId);
  const { data: eventTickets, isLoading: isLoadingTickets } =
    useGetTicketsByEventId({ eventId, communityId: event?.community_id });

  const ticket = eventTickets?.find(
    (ticket) => ticket.user_id === currentUserId,
  );
  const now = DateTime.now();
  const startDate = DateTime.fromISO(event?.start_date ?? '');
  const endDate = event?.scheduled_end_date
    ? DateTime.fromISO(event.scheduled_end_date)
    : undefined;
  const isToday = startDate.hasSame(now, 'day');
  const isPast = startDate < now && !isToday;

  // Event is currently happening if we're between start and end time
  const isCurrentlyHappening =
    now >= startDate && endDate ? now <= endDate : false;

  // Event is within 24 hours if it starts within the next 24 hours (and hasn't started yet)
  const hoursUntilStart = startDate.diff(now, 'hours').hours;
  const isWithin24Hours = hoursUntilStart > 0 && hoursUntilStart <= 24;

  return {
    isLoading: isLoadingEvent || isLoadingTickets || isLoadingLocation,
    isLoadingEvent,
    isLoadingTickets,
    isLoadingLocation,
    ticket,
    isToday,
    isCurrentlyHappening,
    isWithin24Hours,
    location,
    isPast,
    event,
  };
}
